import { render, staticRenderFns } from "./LimitationSectionV2026.vue?vue&type=template&id=430f5ce6&scoped=true"
import script from "./LimitationSectionV2026.vue?vue&type=script&lang=js"
export * from "./LimitationSectionV2026.vue?vue&type=script&lang=js"
import style0 from "./LimitationSectionV2026.vue?vue&type=style&index=0&id=430f5ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430f5ce6",
  null
  
)

export default component.exports